import { useState } from 'react';
import { createModel } from '@features/hox';
import { CODE_SUCCESS } from '@features/constants/network';
import {
  ContentsType,
  LearningInfo,
  RoleType,
  sellerLearningCenterApiClient as apiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { useContents } from '@/pages/Homepage/hooks';

export const usePolicyModel = createModel(() => {
  const { state: initState, actions: initActions } = useContents();
  const [latestPolicy, setLatestPolicy] = useState<LearningInfo[]>([]);
  const [policyCourses, setPolicyCourses] = useState<LearningInfo[]>([]);

  const state = {
    ...initState,
    latestPolicy,
    policyCourses,
  };

  const actions = {
    ...initActions,
    init: async (role: RoleType) => {
      return initActions.init({
        category: ContentsType.Policy_Center,
        role_type: role,
        only_directory: true,
        list_contents_number: 3,
        list_contents_limit: 12,
      });
    },
    loadPage: async (contentId: number, curPage: number) => {
      return initActions.loadPage({
        content_id: contentId,
        page: curPage,
        limit: 12,
      });
    },
    loadLatestPolicy: async () => {
      const res = await apiClient.GetLatestPolicy({ limit: 10 });

      if (res?.code === CODE_SUCCESS) {
        setLatestPolicy(res.learning_info || []);
      }

      return res;
    },
    loadPolicyCourses: async () => {
      const res = await apiClient.GetPolicyCourses({ limit: 10 });

      if (res?.code === CODE_SUCCESS) {
        setPolicyCourses(res.learning_info || []);
      }

      return res;
    },
  };

  return {
    ...state,
    ...actions,
  };
});
